import { render, staticRenderFns } from "./DamageLocatorTruck.vue?vue&type=template&id=e0f83606&scoped=true"
import script from "./DamageLocatorTruck.vue?vue&type=script&lang=ts"
export * from "./DamageLocatorTruck.vue?vue&type=script&lang=ts"
import style0 from "./DamageLocatorTruck.vue?vue&type=style&index=0&id=e0f83606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f83606",
  null
  
)

export default component.exports